import { API } from "@aws-amplify/api";

export const getBolDetailsQuery = (cid: any) => {
  return ``
};
const query = `query MyQuery($input: cidInput!) {
  bolDetails(input: $input){
      customerDetails {
        subTitle
        title
        section {
          dataItems {
            label
            value
          }
          rowItems {
            label
            value
          }
          subTitle
          title
        }
      }
      serviceDates {
        subTitle
        title
        section {
          dataItems {
            label
            value
          }
          subTitle
          title
          rowItems {
            label
            value
          }
        }
      }
      moverCarrier {
        subTitle
        title
        bolNo
        section {
          subTitle
          title
          rowItems {
            label
            value
          }
          dataItems {
            label
            value
          }
        }
      }
}
}`;

export async function getBolDetails(cid: any): Promise<any> {
  try {
    const response: any = await API.graphql({
      query: query, variables: {
        input: {
          customerId: cid
        }
      },
    });
    return response.data;
  } catch (error) {
    console.log("getBolDetails Query lno:20 Error:", error);
  }
}
